<template>
  <div style="height: 100%;">
    <div style="width: 960px">
      <el-row type="flex" justify="end">
        <el-button type="info" icon="el-icon-plus" style="margin-bottom: 10px;" size="small" @click="add()">添加</el-button>
      </el-row>
      <el-table ref="evaluteSet" :data="evaluteSets" empty-text="暂无数据" style="width: 100%;max-height:500px;">
        <el-table-column align="center" type="index" label="评价编号" width="80"></el-table-column>
        <el-table-column align="center" prop="rate" label="评级等级编号" v-if="false"></el-table-column>
        <el-table-column align="center" prop="rateName" label="评级等级" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="message" label="评价自动答复话术"></el-table-column>
        <el-table-column align="center" fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="light" content="修改" placement="bottom">
              <el-button type="text" size="mini" @click="edit(scope.$index, scope.row)">
                <svg class="icon icon-bianji" aria-hidden="true">
                  <use xlink:href="#icontable-bianji" />
                </svg>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="light" content="删除" placement="bottom">
              <el-button type="text" size="mini" @click="deleteByIdx(scope.$index)">
                <svg class="icon icon-delete" aria-hidden="true">
                  <use xlink:href="#icontable-delete" />
                </svg>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="light" content="上移" placement="bottom">
              <el-button size="mini" :disabled="scope.$index===0" @click="moveUp(scope.$index)" style="padding-left: 5px;padding-right: 5px;">
                <i class="el-icon-arrow-up"></i>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="light" content="下移" placement="bottom">
              <el-button size="mini" :disabled="scope.$index===(evaluteSets.length-1)" @click="moveDown(scope.$index)" style="padding-left: 5px;padding-right: 5px;">
                <i class="el-icon-arrow-down"></i>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-row type="flex" justify="center" style="padding-top:20px;">
        <el-button size="medium" @click="cancel()">取消</el-button>
        <el-button size="medium" type="primary" @click="submit()">确定</el-button>
      </el-row>
      <el-dialog :title="dialogTitle" width="560px" :destroy-on-close="true" :visible.sync="addmsg" append-to-body :close-on-click-modal="false" :show-close="false">
        <el-row>
          <div>
            <el-form :inline="true" label-width="130px">
              <el-form-item label="评级等级:">
                <el-select :popper-append-to-body="false" filterable clearable v-model="uform.rate" size="small" style="width:180px;" placeholder="请选择">
                  <el-option v-for="(item, key) in rate_options" :key="key" :label="item" :value="key"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="评价自动答复话术:">
                <el-input type="textarea" v-model="uform.message" maxlength="100" :rows="4" placeholder="最大长度100个字" style="width:380px;"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <el-row type="flex" justify="center">
            <el-button size="medium" @click="modifyCancel()">取消</el-button>
            <el-button size="medium" type="primary" @click="modifySubmit()">确定</el-button>
          </el-row>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      // 新增/编辑 评价等级信息
      dialogTitle: '',
      addmsg: false,
      uform: {
        message: '',
        rate: '',
        rateName: ''
      },
      evaluteSets: [],
      modifyIndex: 0,
      rate_options: {
        1: '非常满意',
        2: '满意',
        3: '一般',
        4: '不满意',
        5: '非常不满意'
      }
    }
  },
  props: {
    evaluateGradeList: {
      type: Array,
      required: true,
      default: () => {
        return []
      }
    }
  },
  mounted() {
    this.evaluteSets = [...this.evaluateGradeList]
  },
  watch: {
  },
  computed: {
  },
  methods: {
    // 展示新增框
    add() {
      this.addmsg = true
      this.uform.message = ''
      this.uform.rate = ''
      this.uform.rateName = ''
      this.dialogTitle = '添加评价等级信息'
    },
    // 展示编辑框
    edit(index, row) {
      this.modifyIndex = index
      this.addmsg = true
      this.uform = { ...row }
      this.dialogTitle = '编辑评价等级信息'
    },
    // 新增/编辑快捷回复内容
    modifySubmit() {
      if (this.uform.rate === '' || this.uform.message.trim().length === 0) {
        this.$message.warning('评级等级或评级自动答复话术不能为空')
        return false
      }
      if (this.dialogTitle === '添加评价等级信息') {
        if (this.evaluteSets.filter(set => set.rate === this.uform.rate).length > 0) {
          this.$message.warning('评价等级已存在，不必新增！')
          return false
        } else {
          this.uform.rateName = this.rate_options[this.uform.rate]
          this.evaluteSets.push({ ...this.uform })
        }
      } else {
        if (this.evaluteSets.filter((set, index, arr) => set.rate === this.uform.rate && index !== this.modifyIndex).length > 0) {
          this.$message.warning('评价等级已存在, 重新修改！')
          return false
        } else {
          this.uform.rateName = this.rate_options[this.uform.rate]
          this.evaluteSets.splice(this.modifyIndex, 1, { ...this.uform })
        }
      }
      this.modifyCancel()
    },
    modifyCancel() {
      this.addmsg = false
      this.uform.message = ''
      this.uform.rate = ''
      this.uform.rateName = ''
    },
    // 单条删除
    deleteByIdx(index) {
      this.$confirm('确认', '', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        showClose: false,
        type: 'warning'
      }).then(() => {
        this.evaluteSets.splice(index, 1)
      })
    },
    moveUp(index) {
      const that = this
      if (index > 0) {
        const up = that.evaluteSets[index - 1] // 要被替换的位置的数据
        // 交换数据位置及内容
        that.evaluteSets.splice(index - 1, 1)
        that.evaluteSets.splice(index, 0, up)
      } else {
        this.$message.warning('已经是第一条，不可上移')
      }
    },
    moveDown(index) {
      const that = this
      if (index + 1 === that.evaluteSets.length) {
        this.$message.warning('已经是最后一条，不可下移')
      } else {
        const down = that.evaluteSets[index + 1]
        // 交换数据位置及内容
        down.execSequence = index
        that.evaluteSets.splice(index + 1, 1)
        that.evaluteSets.splice(index, 0, down)
      }
    },
    cancel() {
      this.evaluteSets = [...this.evaluateGradeList]
      this.$emit('closeEvaluateGradeList')
    },
    submit() {
      this.$emit('closeEvaluateGradeList', [...this.evaluteSets])
    }
  }
}
</script>
<style scoped lang="scss">
.content {
  margin: 0;
  padding: 0;
}
.el-input {
  width: 100%;
}
.search-form.el-form {
  display: flex;
  justify-content: flex-start;
  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 10px;
  }
}
.selectInput {
  line-height: inherit;
}
.el-form-item {
  position: relative;
  ::v-deep .el-form-item__label {
    height: 40px;
    line-height: 40px !important;
  }
  .input-border {
    ::v-deep .el-input__inner {
      padding-left: 5px;
      padding-top: 5px;
      padding-bottom: 5px;
      border-radius: 5px;
      border-bottom: 1px solid #dcdfe6;
      height: 35px;
      line-height: 35px;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-wrap: break-word;
      word-break: break-all;
      &:focus {
        border-bottom: 1px solid #409eff;
      }
    }
  }
  .icon-delete {
    color: #f66f6a;
  }
}

.table-page {
  // margin: 20px 0;
}

.el-dialog .el-dialog__body .el-button + .el-button {
  margin-left: 10px;
}

.el-form-item__content .el-row {
  width: 100% !important;
}
</style>
<style lang="scss">
.el-textarea__inner {
  resize: none !important;
}
.el-pagination.is-background .el-pagination__editor.el-input {
  width: 30px !important;
}
</style>
